import React, { Component } from "react";
import { observer } from "mobx-react";
import moment from "moment";
import { fn_scroll_down, fn_scroll_up } from "function/FnScroll";
import {
  fn_setReturnListInit,
  fn_return_auto_refund,
  fn_return_fail_click,
  fn_return_list_delete,
} from "function/FnBodySetting";
import { partnerIconFg, comma } from "utils/Utils";
import partialiCancelIco from "static-file/images/partialCancel_ico.png";

@observer
class ReturnList extends Component {
  constructor(props) {
    super(props);
    this.inputFocus = React.createRef();
  }

  list = returnList => {
    const { rootStore } = this.props;
    if (Array.isArray(returnList) && returnList.length > 0) {
      return (
        <ul className="list">
          {returnList.map((item, index) => (
            <li
              key={index}
              className={item.mobileOrderNo == rootStore.settingStore.getReturnFailOn.mobileOrderNo ? "on" : ""}
              onClick={event => fn_return_fail_click(rootStore, item)}
            >
              <span className="thumb">
                <span>
                  <img src={partnerIconFg(item)} width="36" height="36" alt={"logo"} />
                </span>
              </span>
              <span className="item">
                <span className="order time">
                  {moment(item.orderTime, "YYYYMMDDHHmmss").format("YYYY/MM/DD HH:mm:ss")}
                </span>
                <span className="order no">{item.mobileOrderNo}</span>
              </span>
              <span className="cont">
                {item.pendingState == "PARTIAL_CANCEL" ? (
                  <img className="partialCancelIco" src={partialiCancelIco} width="60" height="20" alt={"ico"} />
                ) : null}
                <span className="pay">{item.isPrepaid ? "선불" : item.payFg == "01" ? "후불현금" : "후불카드"}</span>
                <span className="pay price">{comma(item.price)}원</span>
              </span>
            </li>
          ))}
        </ul>
      );
    }
  };

  render() {
    const { rootStore } = this.props;
    const layerStore = rootStore.layerStore;
    const returnList = rootStore.settingStore.getReturnFailList;

    return (
      <div className={"layer_comm layer_common_type " + (layerStore.getReturnFailView ? " layer_open" : "")}>
        <div className="bg"></div>
        <div className="layer_content">
          <div className="wrap return">
            <div className="section_tit_comm">
              <h1>반품 매출 미처리 목록</h1>
            </div>
            <div className="section return">
              <h2>취소된 주문의 매출 반품처리가 필요해요</h2>
              <ul className="inner">
                <li className="info">
                  <strong>영업일 고려</strong>하여 반품 처리를 진행하세요
                </li>
                <li className="info">
                  부분 취소는 원주문 반품 후 실매출 임의등록 할게요
                  <br />
                  (이 경우 실제 주문이 취소되는건 아니니 안심하세요)
                </li>
              </ul>
              <h3>반품 매출 미처리 목록</h3>
              <div className="wrap_return_list">
                <div className="scroll scroll_hidden" ref={this.inputFocus}>
                  {this.list(returnList)}
                </div>
                <div className="btns">
                  <button type="button" className="btn_up" onClick={event => fn_scroll_up(this.inputFocus)}>
                    <span></span>
                  </button>
                  <button type="button" className="btn_down" onClick={event => fn_scroll_down(this.inputFocus)}>
                    <span></span>
                  </button>
                </div>
              </div>
              <div className="btn">
                <button
                  className={rootStore.settingStore.getReturnFailOn.mobileOrderNo == "" ? "disabled" : ""}
                  type="button"
                  onClick={event => {
                    rootStore.settingStore.getReturnFailOn.mobileOrderNo == ""
                      ? null
                      : fn_return_list_delete(rootStore);
                  }}
                >
                  목록에서 삭제
                </button>
                <button
                  className={rootStore.settingStore.getReturnFailOn.mobileOrderNo == "" ? "disabled" : ""}
                  type="button"
                  onClick={event => {
                    rootStore.settingStore.getReturnFailOn.mobileOrderNo == ""
                      ? null
                      : fn_return_auto_refund(rootStore, rootStore.settingStore.getReturnFailOn.pendingNo);
                  }}
                >
                  현재 영업일로 반품처리
                </button>
              </div>
            </div>
            <div className="btn_close btn_close_comm">
              <button
                onClick={event => {
                  fn_setReturnListInit(rootStore);
                }}
              >
                <span>닫기</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReturnList;
